import { requestWrapper } from 'e-submission/domain/data'

export const sentEventToGA4 = (user, payload) => {
  return requestWrapper.postRequest(`gtag/send-event`, user, payload).then(({ data }) => data)
}
